<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <div v-if="minimize">
      <CSidebarBrand class="d-md-down-none" to="/">
        <img
          src="@/assets/img/shayan-schools-mono-white.svg"
          class="logo-image"
        />
      </CSidebarBrand>
    </div>
    <div v-else>
      <CSidebarBrand class="d-md-down-none" to="/">
        <img
          src="@/assets/img/shayan-schools-mono-white.svg"
          class="logo-image-small"
        />
        <div class="side-bar-title text-justify">
          <div>سامانه آموزش مجازی</div>
          <div>مدارس شایان</div>
        </div>
      </CSidebarBrand>
    </div>

    <CRenderFunction flat :content-to-render="$options.nav" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  name: "ManagerSidebar",
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
};
</script>
<style lang="scss" scoped>
.side-bar-title {
  font-size: 14px;
  padding-right: 8px;
}

.logo-image-small {
  width: 18%;
}
.logo-image {
  width: 90%;
}
</style>
